export default {
  showSnackbar ({ commit }, snackbars) {
    commit('uiSnackbarsShow', snackbars);
  },
  hideSnackbar ({ commit }) {
    commit('uiSnackbarsHide');
  },
};
